/**
 * This file is generated during
 */
import deployData from '../deploy.json';

const data = {
    version: deployData.version
}

export default data;